import { useState } from "react";
import { useNavigate } from "react-router-dom";

import { Alert, Badge, Button } from "@icg360/design-system";

import { trackEvent } from "utils";

import styles from "./document-sign-row.module.scss";

const DocumentSignRow = ({ documentType, documentStatus, envelopeId }) => {
  const navigate = useNavigate();
  const [showErrorAlert, setShowErrorAlert] = useState(false);

  const linkToDocument = async () => {
    setShowErrorAlert(false);
    trackEvent(`SelfServiceCenter - Sign now clicked`, {
      status: documentStatus,
      documentType,
    });
    navigate(`/my/documents/sign/${envelopeId}`);
  };

  return (
    <>
      {showErrorAlert ? (
        <div className={styles.errorAlertWrapper}>
          <Alert
            title="Something went wrong"
            appearance="danger"
            description="Try again in a few minutes or contact customer support if the problem persists."
            onDismiss={() => setShowErrorAlert(false)}
            dismissible
          />
        </div>
      ) : null}
      <div className={styles.wrapper}>
        <div>
          <div className={styles.title}>
            <div className={styles.documentName}>{documentType}</div>
            <Badge size="compact" appearance="warning">
              Incomplete
            </Badge>
          </div>
          <div>
            Sign required documents to prevent delays in policy activation.
          </div>
        </div>
        <div className={styles.buttonWrapper}>
          <Button size="sm" onPress={linkToDocument}>
            Sign
          </Button>
        </div>
      </div>
    </>
  );
};

export { DocumentSignRow };
